// Counts in-flight HTTP requests so the route loader can wait for a page's
// initial data. A request can opt out with `config.skipRouteLoader = true`
// (e.g. polling or background refreshes).
let pending = 0;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(pending));

export const getPendingRequests = () => pending;

export const subscribePendingRequests = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const start = (cfg) => {
  if (!cfg?.skipRouteLoader && !cfg?._tracked) {
    cfg._tracked = true;
    pending += 1;
    notify();
  }
  return cfg;
};

const end = (cfg) => {
  if (cfg?._tracked) {
    cfg._tracked = false;
    pending = Math.max(0, pending - 1);
    notify();
  }
};

// Attach to an axios instance (or the global axios).
export const trackRequests = (instance) => {
  instance.interceptors.request.use(start);
  instance.interceptors.response.use(
    (response) => {
      end(response?.config);
      return response;
    },
    (error) => {
      end(error?.config);
      return Promise.reject(error);
    }
  );
};
